import { decode } from 'html-entities';
import _ from 'lodash';

const Divisions = {
	
	name: 'Divisions',
	model: {

		idProperty: 'divisions__id',
		displayProperty: 'divisions__name',

		sorters: [
			{
				name: 'divisions__sort_order',
				direction: 'ASC',
			}
		],
		
		properties: [
			{ name: 'divisions__id',	mapping: 'id',	type: 'int', },
			{ name: 'divisions__name',	mapping: 'name', },
			{ name: 'divisions__volume_id',	mapping: 'volume_id',	type: 'int', },
			{ name: 'divisions__parent_id',	mapping: 'parent_id',	type: 'int', },
			{ name: 'divisions__next',	mapping: 'next',	type: 'int', },
			{ name: 'divisions__prev',	mapping: 'prev',	type: 'int', },
			{ name: 'divisions__sort_order',	mapping: 'sort_order',	type: 'int', },

			// { name: 'volumes__id',	mapping: 'volume.id',	type: 'int', },
			// { name: 'volumes__name',	mapping: 'volume.name'},
			// { name: 'volumes__sort_order',	mapping: 'volume.sort_order',	type: 'int', },
		],

		associations: {

			hasMany: [
				'Questions'
			],
			belongsTo: [
				'Volumes'
			],

		},

	},

	entity: {
		methods: {

			getQuestions: function() {
				const Questions = this.getAssociatedRepository('Questions');
				return Questions.getBy((question) => {
					return question.questions__division_id === this.id;
				});
			},

			getQuestionCount: function() {
				if (!this.questionsCount) {
					const questions = this.getQuestions();
					this.questionsCount = questions.length;
				}
				return this.questionsCount;
			},

			getVolume: function() {
				const Volumes = this.getAssociatedRepository('Volumes');
				return Volumes.getById(this.divisions__volume_id);
			},

			getFirstQuestion: function() {
				const Questions = this.getAssociatedRepository('Questions');
				return Questions.getFirstBy((question) => {
					return question.questions__division_id === this.id;
				});
			},

		},
		statics: {
			questionsCount: null,
		},
	},

	repository: {
		type: 'lfr',
		local: {
			type: 'async',
			isPaginated: false,
			autoSave: true,
			methods: {
				decodeHtmlEntities: function () {
					const entities = this.entities;
					_.each(entities, (entity) => {
						entity.divisions__name = decode(entity.divisions__name);
					});
				},
			},
		},
		remote: {
			type: 'onebuild',
			isPaginated: false,
			autoSave: false,
		},
	},

};

export default Divisions;
